import { render } from "./JobHireIcon.vue?vue&type=template&id=ef1849ba&scoped=true"
import script from "./JobHireIcon.vue?vue&type=script&lang=js"
export * from "./JobHireIcon.vue?vue&type=script&lang=js"

import "./JobHireIcon.vue?vue&type=style&index=0&id=ef1849ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1849ba"]])

export default __exports__